<div id="mi-general-details" class="mi-general-details" tabindex="-1" miFocusOnTab>
    @if (this.formisForm.fields.length > 0) {
    <div id="mi-general-details-content ">
        <div class="container">
            <div class="row justify-content-center">
                <div class="  col-12 mi-panel-wrraper  standart">
                    <div class="mi-panel-content">
                        <div class="mc-my-3">
                            <span class="mi-header">{{tabsText().generalDetails}}</span>

                        </div>

                        <div class="mi-white-panel with-shadow">
                            <div class="mi-back ">
                                <mc-button [label]="genericText()?.back" [icon]="'pi pi-fw pi-chevron-right'"
                                class="mi-button-with-icon-primary" id="mi-general-details-back" (click)="back()" (keyup.enter)="back()"></mc-button>
                            </div>

                            <mc-field-form [formisForm]="formisForm">

                            </mc-field-form>

                        </div>
                    </div>
                    <div class="row justify-content-center   justify-content-md-start">
                        <div class=" mi-next blue-button col-md-3 col-12">
                            <mc-button [label]="genericText()?.next + ' >'" (click)="next()"
                                [id]="'mi-general-details-sent'"></mc-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @else{
    <div id="mi-general-details-loaded">
        <mi-genral-skeleton></mi-genral-skeleton>
    </div>
    }


</div>